import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { makeRequest } from "../apis/makeRequest";
import { getProducts } from "../apis/backendRequests";
import ProductCard from "../components/ProductCard";
import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, useMediaQuery, useTheme } from "@mui/material";
import Promociones from "../components/Promociones";
import { ProductBody } from "../components/ProductBody";

const size = (l) => {
  switch (l) {
    case 1:
      return 10;
    case 2:
      return 5;
    case 3:
      return 4;
    default:
      return 3;
  }
};
const randomQueryString = Math.random().toString(36).substring(7);

const Destacados = `${process.env.PUBLIC_URL}/assets/banner-laterales/banner-destacado.jpg?${randomQueryString}`;
const Lanzamientos = `${process.env.PUBLIC_URL}/assets/banner-laterales/banner-lanzamiento.jpg?${randomQueryString}`;



export default function Home() {
  const { searchTerm, categoria, rubro, subRubro, promocion } = useSelector(
    (state) => state.gallery
  );
  const { items } = useSelector((state) => state.cart);

  const account = useSelector((state) => state.account);

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const lastItemRef = useRef()

  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))


  useEffect(() => {
    setPage(1);
  }, [searchTerm, categoria, rubro, subRubro, promocion]);

  useEffect(() => {

    localStorage.setItem("cartItems", JSON.stringify(items));
    localStorage.setItem("orderItems", []);
  }, [items]);

  useEffect(() => {
    let rowsPerPage = Object.keys(account.salesData).length !== 0 ? 35 : 10
    makeRequest(
      () =>
        getProducts(
          account.dynamicsId,
          1,
          rowsPerPage * page,
          searchTerm,
          categoria,
          rubro,
          subRubro,
          promocion
        ),
      (res) => setProducts(res.data)
    );
  }, [account.dynamicsId, searchTerm, categoria, rubro, subRubro, page, promocion]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && entries[0].time > 2000) {
          setPage(page + 1);
        }
      },
      { threshold: 0.9 }
    );

    const current = lastItemRef.current;

    if (current) observer.observe(current);

    return () => observer.disconnect(current);
  });

  const productGrid = products.map((product, i) => {
    return (
      <Grid
        item
        md={size(products.length)}
        key={product.productId}
        ref={i === 10 * page - 1 ? lastItemRef : null}
      >
        <ProductCard product={product} />
      </Grid>
    );
  });

  const ProductTable = () => {
    return (
      <Table stickyHeader sx={{ width: "80%" }} size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">Descripción</TableCell>
            <TableCell align="center">Item</TableCell>
            <TableCell align="center">Precio de lista</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((product, i) => (
            <TableRow key={product.productId} ref={i === 35 * page - 1 ? lastItemRef : null} sx={{
              '&:hover': {
                backgroundColor: '#f2f2f2',
              },
            }}>
              <ProductBody product={product} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };


  const images = [
    {
      label: "DESTACADOS",
      imgPath: Destacados,
    },
    {
      label: "LANZAMIENTOS",
      imgPath: Lanzamientos,
    },
  ];

  if (Object.keys(account.salesData).length !== 0) {
    return (
      <>
        {/* <Grid sx={{ pr: "2%" }} /> */}
        <ProductTable />
        {/* <Grid sx={{ pr: "2%" }} /> */}
      </>
    )
  }

  return (
    <>
      {!mobile && <Grid sx={{ pr: "15%" }} />}
      <div>
        <Grid container spacing={4} sx={{ display: "flex", justifyContent: "center" }}>
          {products.length > 0 ? productGrid : <Box width={"60vw"} />}
        </Grid>
      </div>
      {!mobile && <Grid sx={{ pl: "3%", pr: "1%" }}>
        <Promociones images={images} />
      </Grid>}
    </>
  );
}
